import React,{useState,useEffect} from 'react'
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { invokeTermDates } from '../../ServiceCalls/ApiCalls'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ManageTermDatesComponent() {
  
  const navigate = useNavigate()
  const[createTerm,setCreateTerm] = useState({
        term_name:'',
        term_period:'',
        term_year:''
  })
  const[termName,setTermName] = useState('')
  const[termPeriod,setTermPeriod] = useState('')
  const[termYear,setTermYear] = useState('')
  const[termId,setTermId] = useState('')
  const[rowid,setRowId]= useState('')
  const[termData,setTermData] = useState([])
  const[status,setStatus] = useState(false)
  const[isLoading,setIsLoading] = useState(true)
  const[isRefreshing,setIsRefreshing] = useState(false)

  useEffect(() =>{
    if(!localStorage.getItem('user')){
        navigate('/')
    }
    async function GetData(){
        setIsLoading(true);
        try {
            const term_data_list = await invokeTermDates()
            setTermData(term_data_list)
        } catch (error) {
            console.error('Error fetching term dates:', error);
            toast.error('Failed to load term dates', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    }

    GetData()
  },[])

  const refreshTermDates = async () => {
    setIsRefreshing(true);
    try {
      const term_data_list = await invokeTermDates()
      setTermData(term_data_list)
      
      toast.success('Term dates refreshed successfully!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error refreshing term dates:', error);
      toast.error('Failed to refresh term dates', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsRefreshing(false);
    }
  };

  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
  }
  const handleAddTermDates = (e) => {
    const{name,value} = e.target;
    setCreateTerm({...createTerm,[name]:value})
  }
  
  const handleSubmitTermDates = async(e) =>{

    e.preventDefault()

    //const{term_name,term_period,term_year} = createTerm;

        try {
            const add_termdates_response = await fetch(`${URL}` + '/term/addterm',options("POST",createTerm));
            const termdates_data = await add_termdates_response.json();

            if(add_termdates_response.ok){
                //alert('Term Dates Added !!')
                setTermData([...termData,termdates_data])
                toast.success('🦄 Wow Term Dates Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Term Dates Add Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    
  }

  const deleteTermDates = async(tr_id,rowid) => {

    if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`))
        return
    try{
        const delete_termdates_response = await fetch(`${URL}` + '/term/'+`${tr_id}`, options("DELETE"));
        if(delete_termdates_response.ok){
           // alert(`TermDate at ${rowid+1}  is Deleted !!`)
            const dataDelete = [...termData];
            dataDelete.splice(rowid,1)
            setTermData([...dataDelete])
            toast.success('🦄 Wow Term Dates Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });

        }
        else{
            toast.error('🦄 OOps Term Dates Del Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }catch(err){
        console.log(err)
    }
  }
  const handleTermChange = (e) =>{
    
    const{name,value} = e.target;

    if(name==='term_name')
        setTermName(value)
    if(name === 'term_period')
        setTermPeriod(value)
    if(name === 'term_year')
        setTermYear(value)
  }
  const handleEditTerm = (t,rid) =>{
    setTermName(t.term_name)
    setTermPeriod(t.term_period)
    setTermYear(t.term_year)
    setTermId(t._id)
    setRowId(rid)
    setStatus(false)
  }

  const handleUpdateTermDates = async() =>{
    try {
        const update_term_response = await fetch(`${URL}` + '/term/'+`${termId}`,options("PATCH",{term_name:termName,term_period:termPeriod,term_year:termYear}));

        if(update_term_response.ok){
            const update_term_status = await update_term_response.json();
            const dataUpdate = [...termData]
            dataUpdate[rowid] = update_term_status;
            setTermData([...dataUpdate])
            setStatus(true)
            //toggleRow(rowid)
            toast.success('🦄 Wow Row Updated!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
        else{
           // alert('Update Failed')
           toast.error('🦄 OOps Update Failed!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }

    } catch (error) {
        console.log(error)
    }
  }

  const reset = (e) =>{
    e.preventDefault();
    setCreateTerm({ term_name: '', term_period: '', term_year: '' });
  }

  return (
    <div className="admin-panel">
        <div className='container admin-container'>
            <div className="row mt-5">
              <div className="col-md-12 col-sm-12">
                <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h3 className="mb-1">
                      <i className="fa fa-calendar text-warning me-2"></i>
                      Manage Term Dates ({termData.length})
                    </h3>
                    <p className="text-muted">Add new term dates and manage existing term records</p>
                  </div>
                  <div className="failed-bookings-actions">
                    <button 
                      className="btn btn-outline-secondary me-2"
                      onClick={refreshTermDates}
                      disabled={isRefreshing}
                    >
                      {isRefreshing ? (
                        <>
                          <i className="fa fa-spinner fa-spin me-1"></i>
                          Refreshing...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh me-1"></i>
                          Refresh
                        </>
                      )}
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={() => navigate('/user')}
                    >
                      <i className="fa fa-arrow-left me-1"></i>
                      Back to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Add Term Dates Section */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-plus-circle text-primary me-2"></i>
                    Add New Term Date
                  </h4>
                </div>
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <form onSubmit={handleSubmitTermDates}>
                      <div className="mb-3">
                          <label htmlFor="name" className="form-label">Term Name</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="name" 
                            name="term_name"
                            value={createTerm.term_name}
                            onChange={e => handleAddTermDates(e)} 
                            required
                            placeholder="Enter Term Name" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="designation" className="form-label">Term Period</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="designation" 
                            name="term_period"
                            value={createTerm.term_period} 
                            onChange={e => handleAddTermDates(e)} 
                            required
                            placeholder="Enter Term Period" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="image" className="form-label">Year</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="image"
                            name="term_year"
                            value={createTerm.term_year}
                            required
                            onChange={e => handleAddTermDates(e)} 
                            placeholder="Enter Term Year"/>
                      </div>
                      <div className="d-flex gap-2">
                        <button 
                          type="submit" 
                          className="btn btn-primary">
                          <i className="fa fa-plus me-1"></i>
                          Add Term Date
                        </button>
                        <button 
                          onClick={e => reset(e)}
                          className="btn btn-outline-secondary">
                          <i className="fa fa-refresh me-1"></i>
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Term Dates Section */}
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-list text-warning me-2"></i>
                    Existing Term Dates
                  </h4>
                </div>
                
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                      <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 text-muted">Loading term dates...</p>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th className='text-center'>S.No</th>
                                <th className='text-center'>Term Name</th>
                                <th className='text-center'>Term Period</th>
                                <th className='text-center'>Year</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                termData.length > 0 ?
                                termData.map((t,idx) =><tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>{t.term_name}</td>
                                    <td>{t.term_period}</td>
                                    <td className="text-center">{t.term_year}</td>
                                    <td className="text-center">
                                        <div className="btn-group" role="group">
                                          <button 
                                            className="btn btn-outline-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            onClick={() => handleEditTerm(t,idx)}
                                            title="Edit Term Date"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                          <button 
                                            onClick={() => deleteTermDates(t._id,idx)}
                                            className="btn btn-outline-danger btn-sm"
                                            title="Delete Term Date"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                    </td>
                                </tr>)
                                :
                                <tr>
                                    <td colSpan={5} className="text-center text-muted py-4">
                                      <i className="fa fa-calendar fa-2x mb-2 d-block text-muted"></i>
                                      No term dates found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
        </div>
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="editModalPop">
              <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                      <div className="modal-header">
                          <h5 className="modal-title" id="staticBackdropLabel">Edit Disclaimer</h5>
                          <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              //onClick={() => handleReset()} 
                              aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                          {
                              status ?
                                  <div className="container">
                                      <div className="row my-3">
                                          <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                              <div className="success-img"></div>
                                              <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                          </div>
                                      </div>
                                  </div>
                                  :
                                  <div className="container">
                                      <div className="row my-3">
                                          <div className="col-md-12 col-sm-12">
                                              <label htmlFor="term_name" className="small"><strong>Term</strong></label>
                                              <input
                                                  type="text"
                                                  className='form-control service'
                                                  name="term_name"
                                                  value={termName}
                                                  onChange={e => handleTermChange(e)}
                                                  autoComplete='off'
                                                  id="term_name" />
                                          </div>
                                          <div className="col-md-12 col-sm-12">
                                              <label htmlFor="term_period" className="small"><strong>Period</strong></label>
                                              <input
                                                  type="text"
                                                  className='form-control service'
                                                  name="term_period"
                                                  value={termPeriod}
                                                  onChange={e => handleTermChange(e)}
                                                  autoComplete='off'
                                                  id="term_period" />
                                          </div>
                                          <div className="col-md-12 col-sm-12">
                                              <label htmlFor="term_year" className="small"><strong>Year</strong></label>
                                              <input
                                                  type="text"
                                                  className='form-control service'
                                                  name="term_year"
                                                  value={termYear}
                                                  onChange={e => handleTermChange(e)}
                                                  autoComplete='off'
                                                  id="term_year" />
                                          </div>
                                      </div>
                                  </div>
                          }

                      </div>
                      <div className="modal-footer">
                          {/* <button 
                                    type="button" 
                                    className="btn btn-secondary"
                                    onClick={() => handleReset()} 
                                    data-bs-dismiss="modal">Close</button> */}
                          {
                              status ?
                                  <button
                                      type="button"
                                      className="btn btn-secondary"
                                      //onClick={() => handleReset()} 
                                      data-bs-dismiss="modal">Close</button>
                                  :
                                  <button
                                      onClick={() => handleUpdateTermDates()}
                                      type="button"
                                      className="btn btn-primary">Update</button>
                          }
                      </div>
                  </div>
              </div>
          </div>
        <ToastContainer/>
    </div>
  )
}

export default ManageTermDatesComponent